// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"f9782a9c","149":"b0d1c814","272":"166bdfd2","476":"5a7458ab","577":"2b8db76a","637":"2c322c57","768":"812faf2d","787":"f7f408e1","975":"4b41bbd1"}[chunkId] + ".chunk.js";
};